<footer class="bg-black sticky bottom-0">
  <div class="mx-auto max-w-7xl overflow-hidden px-6 py-4 lg:px-8">
    <div class="mt-4 flex justify-center space-x-10">
      <a href="https://www.facebook.com/ViridisTerraInternational" class="text-gray-400 hover:text-gray-500" target="_blank">
        <span class="sr-only">Facebook</span>
        <vti-icons icon="facebook" size="5" color="text-gray-400 fill-current"></vti-icons>
      </a>
      <a href="https://www.linkedin.com/company/viridis-terra-international/" class="text-gray-400 hover:text-gray-500" target="_blank">
        <span class="sr-only">LinkedIn</span>
        <vti-icons icon="linkedin" size="5" color="text-gray-400"></vti-icons>
      </a>
      <a href="https://twitter.com/ViridisTerraInt" class="text-gray-400 hover:text-gray-500" target="_blank">
        <span class="sr-only">Twitter</span>
        <vti-icons icon="twitter" size="6" color="text-gray-400"></vti-icons>
      </a>
    </div>
    <p class="mt-4 text-center text-xs leading-5 text-gray-500">&copy; 2023 ViridisTerra International, Inc. All rights reserved.</p>
  </div>
</footer>
